import ContinueShoppingLink from './ContinueShoppingLink';


export default ContinueShoppingLink;
